import React, { FC } from 'react';
import TextControl, { TextControlProps } from '../TextControl';
import PasswordInput, { PasswordInputProps } from '../PasswordInput';

export interface PasswordControlProps extends TextControlProps,
Omit<PasswordInputProps, 'Input' | 'defaultValue'| 'name'> {}

export interface PasswordControlStatics {
  labeledControl: boolean;
}

const PasswordControl: FC<PasswordControlProps> & PasswordControlStatics = (props) => (
  <TextControl {...props} Input={PasswordInput} />
);

PasswordControl.labeledControl = true;

export default PasswordControl;
